import { render } from "./LocalidadLOV.vue?vue&type=template&id=5e970918"
import script from "./LocalidadLOV.vue?vue&type=script&lang=js"
export * from "./LocalidadLOV.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__